module.exports = __webpack_public_path__ + "static/Gibson-SemiBold-webfont-cd8d308430b9e2101674f96d0ea21908.svg";